var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-spinner-loader',
    ("dp-spinner-loader--size-" + _vm.size) ]},[_c('div',{staticClass:"dp-spinner-loader__spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }